import { createRoot } from "react-dom/client";
import { UI } from "./UI";

const container = document.getElementById("ui-elements") as HTMLElement;

const root = createRoot(container);
root.render(<UI />);
